import React from "react";
import { useStaticQuery, graphql } from "gatsby";

const Changelog = () => {
  const data = useStaticQuery(graphql`
    query {
      markdownRemark(frontmatter: { path: { eq: "changelog-en" } }) {
        html
        frontmatter {
          date
          path
          title
        }
      }
    }
  `);

  const { markdownRemark } = data;
  const { html, frontmatter } = markdownRemark;

  return (
    <div style={{ padding: "2em" }}>
      {frontmatter.title} ({frontmatter.date})<br />
      <div
        dangerouslySetInnerHTML={{ __html: html }} //eslint-disable-line
      />
    </div>
  );
};

export default Changelog;
